import { PERMISSIONS } from '../../teams/constants/permissions';
import { hasPermission, withResourceWildcard } from '../../teams/utils/hasPermission';

export const resolveBillingPermissions = (permissions) => {
  const can = (permission) => hasPermission(permissions, withResourceWildcard(permission));

  return {
    canViewSubscription: can(PERMISSIONS.GetClientSubscription.value),
    canCreateSubscription: can(PERMISSIONS.CreateClientSubscription.value),
    canUpgradeSubscription: can(PERMISSIONS.UpgradeClientSubscription.value),
    canCancelSubscription: can(PERMISSIONS.CancelClientSubscription.value),
    canDeposit: can(PERMISSIONS.CreateClientDeposit.value),
    canViewInvoices: can(PERMISSIONS.ListInvoices.value),
    canViewBillingProfile: can(PERMISSIONS.GetClientBillingProfile.value),
    canEditBillingProfile:
      can(PERMISSIONS.UpdateClientBillingProfile.value) || can(PERMISSIONS.CreateClientBillingProfile.value),
    canViewPeriodStatements: can(PERMISSIONS.ListPeriodStatements.value),
  };
};
